var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.501,
    height: 52.501,
    viewBox: "0 0 59.501 52.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36953e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ab53f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "newspaper-folded",
    transform: "translate(0 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M74.943,336h-13.6a1.346,1.346,0,1,0,0,2.692h13.6a1.346,1.346,0,1,0,0-2.692Z",
    transform: "translate(-51.923 -268.268)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M225.943,336h-13.6a1.346,1.346,0,1,0,0,2.692h13.6a1.346,1.346,0,1,0,0-2.692Z",
    transform: "translate(-182.596 -268.268)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M95.27,86H61.346a1.346,1.346,0,0,0,0,2.692H95.27a1.346,1.346,0,0,0,0-2.692Z",
    transform: "translate(-51.923 -51.923)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M225.943,136h-13.6a1.346,1.346,0,1,0,0,2.692h13.6a1.346,1.346,0,1,0,0-2.692Z",
    transform: "translate(-182.596 -95.192)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M225.943,186h-13.6a1.346,1.346,0,1,0,0,2.692h13.6a1.346,1.346,0,1,0,0-2.692Z",
    transform: "translate(-182.596 -138.461)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M225.943,236h-13.6a1.346,1.346,0,1,0,0,2.692h13.6a1.346,1.346,0,1,0,0-2.692Z",
    transform: "translate(-182.596 -181.73)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M225.943,286h-13.6a1.346,1.346,0,1,0,0,2.692h13.6a1.346,1.346,0,1,0,0-2.692Z",
    transform: "translate(-182.596 -224.999)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M74.943,286h-13.6a1.346,1.346,0,1,0,0,2.692h13.6a1.346,1.346,0,1,0,0-2.692Z",
    transform: "translate(-51.923 -224.999)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M74.943,136h-13.6A1.346,1.346,0,0,0,60,137.346v13.6a1.346,1.346,0,0,0,1.346,1.346h13.6a1.346,1.346,0,0,0,1.346-1.346v-13.6A1.346,1.346,0,0,0,74.943,136ZM73.6,149.6h-10.9v-10.9H73.6Z",
    transform: "translate(-51.923 -95.192)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M56.809,32.731H52.77V28.692A2.7,2.7,0,0,0,50.078,26H2.692A2.7,2.7,0,0,0,0,28.692V71.77A6.739,6.739,0,0,0,6.731,78.5H52.77A6.739,6.739,0,0,0,59.5,71.77V35.423A2.7,2.7,0,0,0,56.809,32.731Zm0,39.039a4.043,4.043,0,0,1-4.039,4.039H6.731A4.043,4.043,0,0,1,2.692,71.77V28.692H50.078V69.751a3.369,3.369,0,0,0,3.365,3.365,1.346,1.346,0,0,0,0-2.692.674.674,0,0,1-.673-.673V35.423h4.039Z",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.807b45f5e21a34622a8530125334b031.svg";
export { ForwardRef as ReactComponent };